export const KEY_PROFILE = 'profile';
export const KEY_FISHING_MODAL_SEEN = 'fishing_modal_seen';
